<template>
  <responsive-drawer-header
    :badgeColor="'primary'"
    :badgeCount="0"
    :color="theme.appBar.other.color"
    :headerBg="theme.appBar.other.bg"
    :closeDrawerTooltip="$t('closeDrawerHint')"
    :openDrawerTooltip="$t('openDrawerHint')"
    :hasDrawer="false"
  >
    <!-- left container -->
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div class="caption">{{ viewConfig.subTitle }}</div>
    </template>

    <template v-slot:right> </template>
  </responsive-drawer-header>
</template>

<script>
import commonMixin from '@/mixins/common';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';

export default {
  mixins: [commonMixin],
  components: {
    ResponsiveDrawerHeader,
  },
  computed: {
    viewConfig() {
      return this.$route.meta.viewConfig;
    },
  },
};
</script>
